import { api } from "./Configs/AxiosConfigs";
import { defineCancelApiObject } from "./Configs/AxiosUtils";

export const ServiceRequestAPI = {
  sendServiceRequest: async function (formDataJSON, cancel = false) {
    const serviceData = formDataJSON.service_data;

    const serviceId = serviceData?.service_id.toLowerCase().trim();

    const formData = new FormData();

    formData.append("service_data", JSON.stringify({ service_id: serviceId.toUpperCase(), status: serviceData.status, data: { ...serviceData.data.data } }));

    if (serviceData.data?.files) {
      for (let i of Object.keys(serviceData.data?.files)) {
        formData.append(`base64_${i}`, serviceData.data.files[i]);
      }
    }

    const response = await api.request({
      url: `/service-request-${serviceId}`,
      method: "POST",
      data: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      },
      signal: cancel
        ? cancelApiObject[this?.sendServiceRequest?.name]?.handleRequestCancellation()
          ?.signal
        : undefined,
    });
    return response.data;
  },
  getRequestByUser: async function (cancel = false) {
    const response = await api.request({
      url: "/service-request-by-user/",
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      },
      signal: cancel ? cancelApiObject[this?.getRequestByUser?.name]?.handleRequestCancellation()?.signal : undefined,
    })
    return response.data;
  },
  getSaved: async function (practiceNumber) {
    const response = await api.request({
      url: `/service-request-by-number?practice_number=${practiceNumber}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    })
    return response.data;
  },
  getServiceById: async function (id) {
    const response = await api.request({
      url: `/get-service-time/${id}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    })
    return response.data;
  },
  fileUpload: async function (formData) {
    const response = await api.request({
      url: `/service-request-psp-upload-file`,
      method: "POST",
      data: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    })
    return response.data;
  }
};

// defining the cancel API object for ServiceRequestAPI
const cancelApiObject = defineCancelApiObject(ServiceRequestAPI);
